//no custom colors to define as this is comprised of other components that already have colors defined
// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface NewFaxFormColors {}
export const newFaxFormColors: NewFaxFormColors = {}
